import React from "react";
import "./Team.css";
import WOW from 'wowjs';


class Team extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }
    componentDidMount() {
        new WOW.WOW().init();
    }

    render() {
        return (
            <div className="team">
                <div className="container">
                    <h2 className="wow animate__animated animate__fadeIn" data-wow-duration="2s" data-wow-delay="1s" data-wow-offset="30">Team</h2>
                    <div className="team_main" name="Team">
                        <div className="team_block_wrapper">
                            <div className="team_block">
                                <img src="img/Alec.png" />
                                <div className="team_text wow animate__animated animate__fadeInUp" data-wow-duration="1s" data-wow-delay="1s">
                                    <h5>Alec</h5>
                                    <span>Co-Founder</span>
                                </div>
                                <a>
                                    <img className="in wow animate__animated animate__fadeInUp" data-wow-duration="1s" data-wow-delay="1s" src="img/in.svg" />
                                </a>
                            </div>
                        </div>
                        <div className="team_block_wrapper">
                            <div className="team_block">
                                <img src="img/Alec.png" />
                                <div className="team_text wow animate__animated animate__fadeInUp" data-wow-duration="1s" data-wow-delay="1s">
                                    <h5>Alec</h5>
                                    <span>Co-Founder</span>
                                </div>
                                <a>
                                    <img className="in wow animate__animated animate__fadeInUp" data-wow-duration="1s" data-wow-delay="1s" src="img/in.svg" />
                                </a> </div>
                        </div>
                        <div className="team_block_wrapper">
                            <div className="team_block">
                                <img src="img/Alec.png" />
                                <div className="team_text wow animate__animated animate__fadeInUp" data-wow-duration="1s" data-wow-delay="1s">
                                    <h5>Alec</h5>
                                    <span>Co-Founder</span>
                                </div>
                                <a>
                                    <img className="in wow animate__animated animate__fadeInUp" data-wow-duration="1s" data-wow-delay="1s" src="img/in.svg" />
                                </a>
                            </div>
                        </div>
                        <div className="team_block_wrapper">
                            <div className="team_block">
                                <img src="img/Alec.png" />
                                <div className="team_text wow animate__animated animate__fadeInUp" data-wow-duration="1s" data-wow-delay="1s">
                                    <h5>Alec</h5>
                                    <span>Co-Founder</span>
                                </div>
                                <a>
                                    <img className="in wow animate__animated animate__fadeInUp" data-wow-duration="1s" data-wow-delay="1s" src="img/in.svg" />
                                </a>
                            </div>
                        </div>
                        <div className="team_block_wrapper">
                            <div className="team_block">
                                <img src="img/Alec.png" />
                                <div className="team_text wow animate__animated animate__fadeInUp" data-wow-duration="1s" data-wow-delay="1s">
                                    <h5>Alec</h5>
                                    <span>Co-Founder</span>
                                </div>
                                <a >
                                    <img className="in wow animate__animated animate__fadeInUp" data-wow-duration="1s" data-wow-delay="1s" src="img/in.svg" />
                                </a>
                            </div>
                        </div>
                        <div className="team_block_wrapper">
                            <div className="team_block">
                                <img src="img/Alec.png" />
                                <div className="team_text wow animate__animated animate__fadeInUp" data-wow-duration="1s" data-wow-delay="1s">
                                    <h5>Alec</h5>
                                    <span>Co-Founder</span>
                                </div>
                                <a>
                                    <img className="in wow animate__animated animate__fadeInUp" data-wow-duration="1s" data-wow-delay="1s" src="img/in.svg" />
                                </a>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}

export default Team;
